import { toast } from "react-toastify";

export interface ApiError {
	response?: {
		data?: {
			error?: {
				message?: string;
			};
		};
	};
}

export const handleApiError = (
	error: unknown,
	defaultMessage: string
): void => {
	if (error && typeof error === "object" && "response" in error) {
		const apiError = error as ApiError;
		const errorMessage = apiError.response?.data?.error?.message;

		if (errorMessage) {
			toast.error(errorMessage);
			return;
		}
	}

	toast.error(defaultMessage);
};

// biome-ignore lint/suspicious/noExplicitAny: false positive
export const withErrorHandler = <T extends (...args: any[]) => Promise<any>>(
	fn: T,
	errorMessage: string
): ((...args: Parameters<T>) => Promise<ReturnType<T>>) => {
	return async (...args: Parameters<T>): Promise<ReturnType<T>> => {
		try {
			return await fn(...args);
		} catch (error) {
			handleApiError(error, errorMessage);
			throw error;
		}
	};
};

export const createQueryFn = <T>(
	fn: () => Promise<T>,
	errorMessage: string
): (() => Promise<T>) => {
	return async () => {
		try {
			return await fn();
		} catch (error) {
			handleApiError(error, errorMessage);
			throw error;
		}
	};
};
